import React from 'react';
import loadable from '@loadable/component';
import { Props } from './lightbox';

const LightBox = loadable(() =>
  import(/* webpackChunkName: "extra" */ './lightbox')
);

const LoadableLightBox = (props: Props) => <LightBox {...props} />;

export default LoadableLightBox;
